import { render, staticRenderFns } from "./Cases.vue?vue&type=template&id=22f69c0f&scoped=true"
import script from "./Cases.vue?vue&type=script&lang=js"
export * from "./Cases.vue?vue&type=script&lang=js"
import style0 from "./Cases.vue?vue&type=style&index=0&id=22f69c0f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f69c0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f69c0f')) {
      api.createRecord('22f69c0f', component.options)
    } else {
      api.reload('22f69c0f', component.options)
    }
    module.hot.accept("./Cases.vue?vue&type=template&id=22f69c0f&scoped=true", function () {
      api.rerender('22f69c0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/investment-advisor/components/Cases.vue"
export default component.exports